var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "weforsys-opts" },
    [
      _vm._t("left"),
      _vm.isJudgePer
        ? [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "has",
                    rawName: "v-has",
                    value: _vm.addPerCode,
                    expression: "addPerCode",
                  },
                ],
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.add },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.addText === "新建"
                        ? _vm.$t("common.addBtn")
                        : _vm.addText
                    ) +
                    "\n    "
                ),
              ]
            ),
          ]
        : [
            _c(
              "el-button",
              {
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.add },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.addText === "新建"
                        ? _vm.$t("common.addBtn")
                        : _vm.addText
                    ) +
                    "\n    "
                ),
              ]
            ),
          ],
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }